module.exports = __webpack_public_path__ + "img/01_no.f220829a.svg";